import * as React from 'react';

import { Typography } from '@coursera/cds-core';

import Faqs from 'bundles/accomplishments/components/shared/Faqs';

import _t from 'i18n!nls/accomplishments';

export default ({ s12nName, partnerNames, completionDate, specializationFAQs }: $TSFixMe) => {
  const question = _t('How should I list my course on my resume/C.V.?');
  const answer = _t(
    'We recommend #{s12nName} by #{partnerNames} on Coursera. Certificate earned at #{completionDate}',
    {
      s12nName,
      partnerNames,
      completionDate,
    }
  );

  const faqs = [{ question, answer }, ...(specializationFAQs || [])];

  return (
    <div className="faq-section">
      <Typography className="faq-header" variant="h2semibold" component="h3">
        {_t('Frequently Asked Questions')}
      </Typography>
      <Faqs faqs={faqs} />
    </div>
  );
};
